import type {ReactNode} from 'react';
import {Link} from 'react-router';
import {useTranslation} from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowRight} from '@fortawesome/free-solid-svg-icons';

type IndexSectionHeadingProps = {
    title: string;
    to?: string;
    linkLabel?: string;
    compactLink?: boolean;
    actions?: ReactNode;
};

const IndexSectionHeading = ({
    title,
    to,
    linkLabel,
    compactLink = false,
    actions,
}: IndexSectionHeadingProps) => {
    const {t} = useTranslation();
    const label = linkLabel ?? t('index.see_all');

    return (
        <div className="index-home-section-heading shrink-0">
            <h2 className="min-w-0">{title}</h2>
            <div className="index-home-heading-actions shrink-0">
                {actions}
                {to && (
                    <Link
                        to={to}
                        className="index-home-section-link"
                        aria-label={`${label} ${title}`}>
                        <span className={compactLink ? 'sr-only' : undefined}>
                            {label}
                        </span>
                        <FontAwesomeIcon icon={faArrowRight} />
                    </Link>
                )}
            </div>
        </div>
    );
};

export default IndexSectionHeading;
